import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import frenchMessages from "ra-language-french";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { raSupabaseFrenchMessages } from "ra-supabase-language-french";
import { englishCrmMessages } from "./englishCrmMessages";
import { frenchCrmMessages } from "./frenchCrmMessages";
import { portugueseCrmMessages } from "./portugueseCrmMessages";

const raPortugueseMessages = {
  ra: {
    action: {
      add_filter: "Adicionar filtro",
      add: "Adicionar",
      back: "Voltar",
      bulk_actions: "1 item selecionado |||| %{smart_count} itens selecionados",
      cancel: "Cancelar",
      clear_array_input: "Limpar a lista",
      clear_input_value: "Limpar valor",
      clone: "Clonar",
      confirm: "Confirmar",
      create: "Criar",
      create_item: "Criar %{item}",
      delete: "Excluir",
      edit: "Editar",
      export: "Exportar",
      list: "Listar",
      refresh: "Atualizar",
      remove_filter: "Remover este filtro",
      remove_all_filters: "Remover todos os filtros",
      remove: "Remover",
      reset: "Redefinir",
      save: "Salvar",
      search: "Buscar",
      search_columns: "Buscar colunas",
      select_all: "Selecionar todos",
      select_all_button: "Selecionar todos",
      select_row: "Selecionar esta linha",
      show: "Ver",
      sort: "Ordenar",
      undo: "Desfazer",
      unselect: "Desmarcar",
      expand: "Expandir",
      close: "Fechar",
      open_menu: "Abrir menu",
      close_menu: "Fechar menu",
      update: "Atualizar",
      move_up: "Mover para cima",
      move_down: "Mover para baixo",
      open: "Abrir",
      toggle_theme: "Alternar modo claro/escuro",
      select_columns: "Colunas",
      update_application: "Recarregar aplicativo",
    },
    boolean: {
      true: "Sim",
      false: "Não",
      null: " ",
    },
    page: {
      create: "Criar %{name}",
      dashboard: "Painel",
      edit: "%{name} %{recordRepresentation}",
      error: "Algo deu errado",
      list: "%{name}",
      loading: "Carregando",
      not_found: "Não encontrado",
      show: "%{name} %{recordRepresentation}",
      empty: "Nenhum %{name} ainda.",
      invite: "Deseja adicionar um?",
      access_denied: "Acesso negado",
      authentication_error: "Erro de autenticação",
    },
    input: {
      file: {
        upload_several:
          "Arraste alguns arquivos para enviar ou clique para selecionar um.",
        upload_single:
          "Arraste um arquivo para enviar ou clique para selecionar.",
      },
      image: {
        upload_several:
          "Arraste algumas imagens para enviar ou clique para selecionar uma.",
        upload_single:
          "Arraste uma imagem para enviar ou clique para selecionar.",
      },
      references: {
        all_missing: "Não foi possível encontrar dados de referência.",
        many_missing:
          "Pelo menos uma das referências associadas não está mais disponível.",
        single_missing: "A referência associada não está mais disponível.",
      },
      password: {
        toggle_visible: "Ocultar senha",
        toggle_hidden: "Exibir senha",
      },
    },
    message: {
      about: "Sobre",
      access_denied: "Você não tem permissão para acessar esta página",
      are_you_sure: "Tem certeza?",
      authentication_error:
        "O servidor de autenticação retornou um erro e suas credenciais não puderam ser verificadas.",
      auth_error: "Ocorreu um erro ao validar o token de autenticação.",
      bulk_delete_content:
        "Tem certeza de que deseja excluir este %{name}? |||| Tem certeza de que deseja excluir estes %{smart_count} itens?",
      bulk_delete_title: "Excluir %{name} |||| Excluir %{smart_count} %{name}",
      bulk_update_content:
        "Tem certeza de que deseja atualizar %{name} %{recordRepresentation}? |||| Tem certeza de que deseja atualizar estes %{smart_count} itens?",
      bulk_update_title:
        "Atualizar %{name} %{recordRepresentation} |||| Atualizar %{smart_count} %{name}",
      clear_array_input: "Tem certeza de que deseja limpar toda a lista?",
      delete_content: "Tem certeza de que deseja excluir este %{name}?",
      delete_title: "Excluir %{name} %{recordRepresentation}",
      details: "Detalhes",
      error:
        "Ocorreu um erro no cliente e sua solicitação não pôde ser concluída.",
      invalid_form: "O formulário é inválido. Verifique se há erros",
      loading: "Aguarde",
      no: "Não",
      not_found: "Você digitou uma URL incorreta ou seguiu um link quebrado.",
      select_all_limit_reached:
        "Existem muitos elementos para selecionar todos. Apenas os primeiros %{max} elementos foram selecionados.",
      unsaved_changes:
        "Algumas das suas alterações não foram salvas. Tem certeza de que deseja ignorá-las?",
      yes: "Sim",
      placeholder_data_warning: "Problema de rede: falha ao atualizar dados.",
    },
    navigation: {
      clear_filters: "Limpar filtros",
      no_filtered_results: "Nenhum %{name} encontrado com os filtros atuais.",
      no_results: "Nenhum %{name} encontrado",
      no_more_results:
        "A página %{page} está fora dos limites. Tente a página anterior.",
      page_out_of_boundaries: "Número de página %{page} fora dos limites",
      page_out_from_end: "Não é possível avançar além da última página",
      page_out_from_begin: "Não é possível voltar antes da página 1",
      page_range_info: "%{offsetBegin}-%{offsetEnd} de %{total}",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} de mais de %{offsetEnd}",
      current_page: "Página %{page}",
      page: "Ir para a página %{page}",
      first: "Ir para a primeira página",
      last: "Ir para a última página",
      next: "Ir para a próxima página",
      previous: "Ir para a página anterior",
      page_rows_per_page: "Linhas por página:",
      skip_nav: "Ir para o conteúdo",
    },
    sort: {
      sort_by: "Ordenar por %{field_lower_first} %{order}",
      ASC: "crescente",
      DESC: "decrescente",
    },
    auth: {
      auth_check_error: "Faça login para continuar",
      user_menu: "Perfil",
      username: "Nome de usuário",
      password: "Senha",
      email: "E-mail",
      sign_in: "Entrar",
      sign_in_error: "Falha na autenticação, tente novamente",
      logout: "Sair",
    },
    notification: {
      updated: "Elemento atualizado |||| %{smart_count} elementos atualizados",
      created: "Elemento criado",
      deleted: "Elemento excluído |||| %{smart_count} elementos excluídos",
      bad_item: "Elemento incorreto",
      item_doesnt_exist: "Elemento não existe",
      http_error: "Erro de comunicação com o servidor",
      data_provider_error:
        "Erro do dataProvider. Verifique o console para mais detalhes.",
      i18n_error:
        "Não foi possível carregar as traduções para o idioma especificado",
      canceled: "Ação cancelada",
      logged_out: "Sua sessão foi encerrada, por favor conecte-se novamente.",
      not_authorized: "Você não tem autorização para acessar este recurso.",
      application_update_available: "Uma nova versão está disponível.",
      offline: "Sem conexão. Não foi possível buscar os dados.",
    },
    validation: {
      required: "Obrigatório",
      minLength: "Deve ter pelo menos %{min} caracteres",
      maxLength: "Deve ter %{max} caracteres ou menos",
      minValue: "Deve ser no mínimo %{min}",
      maxValue: "Deve ser no máximo %{max}",
      number: "Deve ser um número",
      email: "Deve ser um e-mail válido",
      oneOf: "Deve ser um dos seguintes: %{options}",
      regex: "Deve corresponder a um formato específico (regexp): %{pattern}",
      unique: "Deve ser único",
    },
    saved_queries: {
      label: "Consultas salvas",
      query_name: "Nome da consulta",
      new_label: "Salvar consulta atual...",
      new_dialog_title: "Salvar consulta atual como",
      remove_label: "Remover consulta salva",
      remove_label_with_name: 'Remover consulta "%{name}"',
      remove_dialog_title: "Remover consulta salva?",
      remove_message:
        "Tem certeza de que deseja remover este item da sua lista de consultas salvas?",
      help: "Filtre a lista e salve esta consulta para mais tarde",
    },
    guesser: {
      empty: {
        title: "Nenhum dado para exibir",
        message: "Verifique seu provedor de dados",
      },
    },
    configurable: {
      customize: "Personalizar",
      configureMode: "Configurar esta página",
      inspector: {
        title: "Inspecionar",
        content:
          "Passe o mouse sobre os elementos da interface para configurá-los",
        reset: "Restaurar configurações",
        hideAll: "Ocultar tudo",
        showAll: "Exibir tudo",
      },
      Datagrid: {
        title: "Tabela",
        unlabeled: "Coluna sem rótulo #%{column}",
      },
      SimpleForm: {
        title: "Formulário",
        unlabeled: "Campo sem rótulo #%{input}",
      },
      SimpleList: {
        title: "Lista",
        primaryText: "Texto principal",
        secondaryText: "Texto secundário",
        tertiaryText: "Texto terciário",
      },
    },
  },
};

const raSupabasePortugueseMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset:
        "Verifique seu e-mail para encontrar a mensagem de redefinição de senha.",
    },
    oauth: {
      authorize: "Autorizar Aplicativo",
      authorize_details: "Este aplicativo deseja acessar sua conta.",
      access_scope:
        "Ele poderá ler e modificar seus dados, com as mesmas permissões da sua conta.",
      approved: "Autorização Aprovada",
      close_tab: "Você já pode fechar esta aba.",
      no_request: "Nenhuma solicitação de autorização encontrada",
    },
  },
};

const raSupabaseEnglishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Check your emails for a Reset Password message.",
    },
    oauth: {
      authorize: "Authorize Application",
      authorize_details: "This application wants to access your account.",
      access_scope:
        "It will be able to read and modify your data, with the same permissions as your account.",
      approved: "Authorization Approved",
      close_tab: "You can now close this tab.",
      no_request: "No authorization request found",
    },
  },
};

const raSupabaseFrenchMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset:
        "Consultez vos emails pour trouver le message de reinitialisation du mot de passe.",
    },
    oauth: {
      authorize: "Autoriser l'application",
      authorize_details: "Cette application souhaite accéder à votre compte.",
      access_scope:
        "Elle pourra lire et modifier vos données, avec les mêmes droits que votre compte.",
      approved: "Autorisation accordée",
      close_tab: "Vous pouvez fermer cet onglet.",
      no_request: "Aucune demande d'autorisation trouvée",
    },
  },
};

const englishCatalog = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  raSupabaseEnglishMessagesOverride,
  englishCrmMessages,
);

const frenchCatalog = mergeTranslations(
  englishCatalog,
  frenchMessages,
  raSupabaseFrenchMessages,
  raSupabaseFrenchMessagesOverride,
  frenchCrmMessages,
);

const portugueseCatalog = mergeTranslations(
  englishCatalog,
  raPortugueseMessages,
  raSupabasePortugueseMessagesOverride,
  portugueseCrmMessages,
);

// Cultivar's team works in Portuguese: always start in pt-BR, whatever the
// browser language. Users can still switch language from the app menu.
export const getInitialLocale = (): "pt" | "en" | "fr" => "pt";

export const i18nProvider = polyglotI18nProvider(
  (locale) => {
    if (locale === "en") {
      return englishCatalog;
    }
    if (locale === "fr") {
      return frenchCatalog;
    }
    return portugueseCatalog;
  },
  getInitialLocale(),
  [
    { locale: "pt", name: "Português (BR)" },
    { locale: "en", name: "English" },
    { locale: "fr", name: "Français" },
  ],
  { allowMissing: true },
);

export const testI18nProvider = polyglotI18nProvider(
  (locale) => {
    if (locale === "en") {
      return englishCatalog;
    }
    if (locale === "fr") {
      return frenchCatalog;
    }
    return portugueseCatalog;
  },
  "pt",
  [
    { locale: "pt", name: "Português (BR)" },
    { locale: "en", name: "English" },
    { locale: "fr", name: "Français" },
  ],
  { allowMissing: true },
);
